import React from "react";

export default function LegalPage({ title, eyebrow = "Legal", children, testid }) {
  return (
    <div
      data-testid={testid}
      className="max-w-3xl mx-auto px-6 md:px-12 py-20 md:py-28"
    >
      <p className="label-eyebrow fade-up">{eyebrow}</p>
      <h1 className="font-serif text-4xl md:text-5xl font-light text-[#2D2926] mt-4 tracking-tight fade-up-delay-1">
        {title}
      </h1>
      <div className="prose prose-stone mt-12 fade-up-delay-2 max-w-none text-[#5B5653] leading-relaxed space-y-6 [&_h2]:font-serif [&_h2]:text-2xl [&_h2]:font-light [&_h2]:text-[#2D2926] [&_h2]:mt-12 [&_h2]:mb-4 [&_h2]:tracking-tight [&_p]:text-base [&_p]:leading-relaxed [&_a]:text-[#E25C46] [&_a]:underline [&_a]:underline-offset-4 [&_strong]:text-[#2D2926] [&_strong]:font-medium [&_ul]:list-disc [&_ul]:pl-6 [&_ul]:space-y-2 [&_li]:text-base">
        {children}
      </div>
    </div>
  );
}
